import React, { useContext } from "react";
import { RecordingsFilterContext } from "../pages/ProjectPage";
import { recordingStatuses, statusColor } from "../../constants";
import { Button } from "semantic-ui-react";

const userFilters = [
  {
    text: "Show All",
    value: recordingStatuses.ALL,
    color: statusColor(recordingStatuses.ALL),
  },
  {
    text: "Done",
    value: recordingStatuses.DONE,
    color: statusColor(recordingStatuses.DONE),
  },
  {
    text: "Questionable",
    value: recordingStatuses.QUESTIONABLE,
    color: statusColor(recordingStatuses.QUESTIONABLE),
  },
  {
    text: "Bad",
    value: recordingStatuses.BAD,
    color: statusColor(recordingStatuses.BAD),
  },
  {
    text: "No Recording",
    value: recordingStatuses.NO_RECORDING,
    color: statusColor(recordingStatuses.NO_RECORDING),
  },
];
const reviewerFilters = [
  {
    text: "Show All",
    value: recordingStatuses.ALL,
    color: statusColor(recordingStatuses.ALL),
  },
  {
    text: "Approved",
    value: recordingStatuses.APPROVED,
    color: statusColor(recordingStatuses.APPROVED),
  },
  {
    text: "Redo",
    value: recordingStatuses.REDO,
    color: statusColor(recordingStatuses.REDO),
  },
  {
    text: "Unreviewed",
    value: recordingStatuses.UNREVIEWED,
    color: statusColor(recordingStatuses.UNREVIEWED),
  },
];

const ProjectFilterButtons = () => {
  const { filters, setFilters } = useContext(RecordingsFilterContext);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-end",
      }}
    >
      {/* user filter button */}
      <Button.Group size="small" floated="right">
        {userFilters.map((filter, i) => {
          const active = filters.user === filter.value;
          const color = active ? filter.color : null;
          return (
            <Button
              compact
              key={i}
              active={active}
              color={color}
              content={filter.text}
              onClick={() => {
                setFilters({ ...filters, user: filter.value });
              }}
            />
          );
        })}
      </Button.Group>
      {/* reviewer filter buttons */}
      <Button.Group size="small" floated="right">
        {reviewerFilters.map((filter, i) => {
          const active = filters.reviewer === filter.value;
          const color = active ? filter.color : null;
          return (
            <Button
              compact
              key={i}
              active={active}
              color={color}
              content={filter.text}
              onClick={() => {
                setFilters({ ...filters, reviewer: filter.value });
              }}
            />
          );
        })}
      </Button.Group>
    </div>
  );
};

export default ProjectFilterButtons;
